module.exports = __webpack_public_path__ + "img/ApprTemp4.13e2f7e6.png";